import { render, staticRenderFns } from "./InputRelatedCustomer.vue?vue&type=template&id=70bb42aa&scoped=true"
import script from "./InputRelatedCustomer.vue?vue&type=script&lang=ts"
export * from "./InputRelatedCustomer.vue?vue&type=script&lang=ts"
import style0 from "./InputRelatedCustomer.vue?vue&type=style&index=0&id=70bb42aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bb42aa",
  null
  
)

export default component.exports